import React from 'react'
import EnrolmentView from './views'
import CCMSGovEnrolments from './ccms-gov-enrolments'
import CCSGovEnrolments from './ccs-gov-enrolments'
import ACCSGovEnrolments from './accs-gov-enrolments'

export const CareEnrolment = ({
  record,
  base_url,
  dispatchAction,
  regHolderId,
  regHolderType,
}) => (
  <EnrolmentView record={record} base_url={base_url}>
    <CCSGovEnrolments
      key={'ccs_enrolments' + record.id}
      child={record}
      dispatchAction={dispatchAction}
      regHolderId={regHolderId}
      regHolderType={regHolderType}
    />
    <ACCSGovEnrolments
      key={'accs_enrolments' + record.id}
      child={record}
      regHolderId={regHolderId}
    />
    <CCMSGovEnrolments
      key={'ccms_enrolments' + record.id}
      child={record}
      dispatchAction={dispatchAction}
    />
  </EnrolmentView>
)

export default CareEnrolment



// WEBPACK FOOTER //
// ./src/care-enrolments/details/container.js